// extracted by mini-css-extract-plugin
module.exports = {"item":"a10a3f92e9--item--_szzM","item--v2":"a10a3f92e9--item--v2--zKQNx","image":"a10a3f92e9--image--wxBS6","content":"a10a3f92e9--content--Koa7N"};